import { lopBoMonHocSinhActions } from './lopBoMonHocSinhActions';
import { lopBoMonListActions } from './lopBoMonListActions';
import { lopBoMonSoDiemActions } from './lopBoMonSoDiemActions';
import { lopBoMonTypeActions } from './lopBoMonTypeActions';
export const lopBoMonActionWrapper = {
    lopBoMonList: lopBoMonListActions,
    lopBoMonHocSinh: lopBoMonHocSinhActions,
    lopBoMoSoDiem: lopBoMonSoDiemActions,
    lopBoMonType: lopBoMonTypeActions
}